import AccountInfoPage from '@fhs-legacy/frontend/src/pages/account/account-info';
export { ErrorBoundary } from '@fhs/routing/src/components/page-dev-error-boundary';

export default AccountInfoPage;
